import { render, staticRenderFns } from "./Actividad.vue?vue&type=template&id=f87c85de&scoped=true&"
import script from "./Actividad.vue?vue&type=script&lang=js&"
export * from "./Actividad.vue?vue&type=script&lang=js&"
import style0 from "./Actividad.vue?vue&type=style&index=0&id=f87c85de&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f87c85de",
  null
  
)

export default component.exports